export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"charset":"utf-8"},{"name":"description","content":"Elevate your NCAA baseball journey with 64Analytics. Gain an edge with our advanced player ranking system, comprehensive statistics, and exclusive NCAA transfer portal coverage. Discover data-driven strategies for success and secure your path to the MLB. Start your analytics-driven baseball journey today."},{"hid":"og-type","property":"og:type","content":"website"},{"hid":"og-title","property":"og:title","content":"64 Analytics | 64Analytics.com"},{"hid":"og-desc","property":"og:description","content":"Elevate your NCAA baseball journey with 64Analytics. Gain an edge with our advanced player ranking system, comprehensive statistics, and exclusive NCAA transfer portal coverage. Discover data-driven strategies for success and secure your path to the MLB. Start your analytics-driven baseball journey today."},{"hid":"og-image","property":"og:image","content":"/images/social-square.png"}],"link":[{"rel":"icon","type":"image/png","href":"/images/favicon.png"}],"style":[],"script":[],"noscript":[{"children":"<img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=1247326690367492&ev=PageView&noscript=1\" />"}],"charset":"utf-8","viewport":"width=device-width, initial-scale=1.0"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true